import { normalizedIncludes } from "@/utils/textSearch";

const patchedOptions = new WeakSet();

const isLocalElementSelect = (component) => {
  return component?.$options?.name === "ElSelect"
    && !component.$props?.remote
    && typeof component.$props?.filterMethod !== "function";
};

const patchOption = (option) => {
  if (!option || patchedOptions.has(option) || !option.states || typeof option.updateOption !== "function") {
    return false;
  }

  option.updateOption = (query = "") => {
    option.states.visible = normalizedIncludes(option.currentLabel, query) || Boolean(option.created);
  };
  patchedOptions.add(option);

  return true;
};

const patchSelectOptions = (select) => {
  if (!isLocalElementSelect(select) || !Array.isArray(select.optionsArray)) {
    return;
  }

  const hasNewPatchedOptions = select.optionsArray
    .map(patchOption)
    .some(Boolean);

  if (hasNewPatchedOptions && typeof select.updateOptions === "function") {
    select.updateOptions();
  }
};

export default {
  install(app) {
    app.mixin({
      mounted() {
        patchSelectOptions(this);
      },
      updated() {
        patchSelectOptions(this);
      }
    });
  }
};
